"use client";

import { trackMetrixEventByName } from "@/services/metrixAnalyticsService";

const MAX_PARAM_LENGTH = 500;

const isPlainObject = (value) => {
  return Object.prototype.toString.call(value) === "[object Object]";
};

const normalizeParamValue = (value) => {
  if (value === undefined || value === null || value === "") return undefined;

  if (typeof value === "number" || typeof value === "boolean") return value;

  if (value instanceof Date) return value.toISOString();

  if (Array.isArray(value) || isPlainObject(value)) {
    try {
      return JSON.stringify(value).slice(0, MAX_PARAM_LENGTH);
    } catch (_error) {
      return undefined;
    }
  }

  return String(value).slice(0, MAX_PARAM_LENGTH);
};

export const sanitizeGtagParams = (params = {}) => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    const normalizedValue = normalizeParamValue(value);
    if (normalizedValue !== undefined) acc[key] = normalizedValue;
    return acc;
  }, {});
};

export const trackGtagEvent = (eventName, params = {}) => {
  if (!eventName || typeof window === "undefined") {
    return false;
  }

  const safeParams = sanitizeGtagParams(params);
  trackMetrixEventByName(eventName, safeParams);

  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, safeParams);
    return true;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(["event", eventName, safeParams]);
  return true;
};

export const getScreenNameFromPath = (pathname = "/") => {
  if (!pathname || pathname === "/") return "home";
  return pathname.split("?")[0].split("/").filter(Boolean).join("_") || "home";
};

export const isTvUserAgent = (userAgent = "") => {
  const ua = userAgent.toLowerCase();
  return [
    "smart-tv",
    "smarttv",
    "tizen",
    "webos",
    "web0s",
    "android tv",
    "googletv",
    "bravia",
    "hbbtv",
    "netcast",
    "appletv",
    "aft",
  ].some((token) => ua.includes(token));
};
